import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { deductionSummarySelector } from '../selectors'
import { handleRequestError } from './request'
import { updateAndSaveActiveTaxReturn } from './tax-return'

export const REQUEST_DEDUCTION_SUMMARY = 'REQUEST_DEDUCTION_SUMMARY'
export const RECEIVE_DEDUCTION_SUMMARY = 'RECEIVE_DEDUCTION_SUMMARY'
export const SAVE_DEDUCTION_SUMMARY = 'SAVE_DEDUCTION_SUMMARY'
const CREATE_DEDUCTION_SUMMARY = 'CREATE_DEDUCTION_SUMMARY'

export const requestDeductionSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_DEDUCTION_SUMMARY, data: { taxReturnId } })

    return axios
        .get(`/deductionsummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveDeductionSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveDeductionSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveDeductionSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveDeductionSummary = (data) => ({ type: RECEIVE_DEDUCTION_SUMMARY, data })

export const saveDeductionSummary = (data) => (dispatch, getState) => {
    dispatch({ type: SAVE_DEDUCTION_SUMMARY, data })

    const { id: taxReturnId } = getState().taxReturn

    return axios
        .put(`/deductionsummaries/${taxReturnId}`, { ...data, taxReturnId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveDeductionSummary(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSaveDeductionSummary = (data) => (dispatch, getState) => {
    const { deductionSummary } = deductionSummarySelector(getState())
    const updatedDeductionSummary = { ...deductionSummary, ...data }

    dispatch(receiveDeductionSummary(updatedDeductionSummary))
    return dispatch(saveDeductionSummary(updatedDeductionSummary)).catch(() => {})
}

export const updateAndSaveDeductionSummaryStatus =
    ({ status }) =>
    (dispatch, getState) => {
        const { deductionSummary } = deductionSummarySelector(getState())
        const updatedDeductionSummary = { ...deductionSummary, status }

        dispatch(receiveDeductionSummary(updatedDeductionSummary))
        return dispatch(saveDeductionSummary(updatedDeductionSummary))
            .then(() => dispatch(updateAndSaveActiveTaxReturn({ deductionSummaryStatus: status })))
            .catch(() => {})
    }

export const createDeductionSummary =
    (data = {}) =>
    (dispatch, getState) => {
        const { id: taxReturnId } = getState().taxReturn

        dispatch({ type: CREATE_DEDUCTION_SUMMARY })

        return axios
            .put(`/deductionsummaries/${taxReturnId}`, data)
            .then((response) => {
                const responseData = response?.data || {}
                dispatch(receiveDeductionSummary(responseData))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const createOrUpdateDeductionSummary = (data) => (dispatch, getState) => {
    const { deductionSummary, hasDeductionSummary } = deductionSummarySelector(getState())

    const persist = hasDeductionSummary ? updateAndSaveDeductionSummary : createDeductionSummary
    return dispatch(persist({ ...deductionSummary, ...data }))
}
